import { render } from "./WishlistSchemaJson.vue?vue&type=template&id=82098376"
import script from "./WishlistSchemaJson.vue?vue&type=script&lang=js"
export * from "./WishlistSchemaJson.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__